import PlatformDashboard from "../../domain/dashboard/components/PlatformDashboard";
import "./DashboardPage.scss";

export default function DashboardPage() {
  return (
    <div className="dashboard-page">
      <PlatformDashboard />
    </div>
  );
}
